    <template>
        <div class="ele-body">
            <el-card shadow="never">
                <!-- 搜索表单 -->
                <el-form v-if="search_show" :model="table.where" label-width="auto" :inline="true"
                    @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
                    <el-row :gutter="15">


                        <el-form-item label="商品名称:">
                            <el-input v-model="table.where.name" placeholder="请输入商品名称" clearable />
                        </el-form-item>
                        <el-form-item label="商品编号:">
                            <el-input v-model="table.where.goods_code" placeholder="请输入商品编号" clearable />
                        </el-form-item>


                        <el-form-item label="生产企业:">
                            <el-input v-model="table.where.enterprise" placeholder="请输入生产企业" clearable />
                        </el-form-item>

                        <el-form-item label="品牌:">
                            <el-input v-model="table.where.brand" placeholder="请输入品牌" clearable />
                        </el-form-item>

                        <el-form-item label="产地:">
                            <el-input v-model="table.where.producer" placeholder="请输入产地" clearable />
                        </el-form-item>


                        <el-form-item label="类型:">
                            <el-input v-model="table.where.type" placeholder="请输入类型" clearable />
                        </el-form-item>

                        <el-form-item label="规格:">
                            <el-input v-model="table.where.specs" placeholder="请输入规格" clearable />
                        </el-form-item>

                        <el-form-item label="排序:">
                            <el-input-number v-model="table.where.sort" placeholder="请输入排序" :controls="false"
                                controls-position="right" class="ele-fluid ele-text-left" clearable />
                        </el-form-item>

                        <el-form-item label="创建时间:">
                            <el-date-picker v-model="table.where.create_time" type="datetimerange"
                                start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd hh:mm:ss">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search"
                                class="ele-btn-icon">查询
                            </el-button>
                            <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
                            <el-button type="success" @click="exportExcel();" icon="el-icon-download"
                                class="ele-btn-icon" v-if="permission.includes('sys:tracinggoods:export')">导出数据
                            </el-button>
                        </el-form-item>
                    </el-row>
                </el-form>
                <!-- 操作按钮 -->

                <div class="ele-table-tool ele-table-tool-default">
                    <el-button @click="(table.where={})&&$refs.table.reload()" type="info" icon="el-icon-refresh"
                        class="ele-btn-icon" size="small">刷新
                    </el-button>
                    <el-button @click="showEdit=true" type="primary" icon="el-icon-plus" class="ele-btn-icon"
                        size="small" v-if="permission.includes('sys:tracinggoods:add')">添加
                    </el-button>
                    <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small"
                        v-if="permission.includes('sys:tracinggoods:dall')">批量删除
                    </el-button>
                    <el-button :type="search_show?'warning':'info'" size="small" icon="el-icon-search"
                        @click="search_show=!search_show">搜索</el-button>
                </div>

                <!-- 数据表格 -->
                <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)"
                    highlight-current-row>
                    <template slot-scope="{index}">
                        <el-table-column type="selection" width="45" align="center" fixed="left" />
                        <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left"
                            show-overflow-tooltip />

                        <el-table-column prop="name" label="商品名称" sortable="custom" show-overflow-tooltip
                            min-width="120" />
                        <el-table-column prop="code_nei_image" label="内盖二维码" show-overflow-tooltip min-width="250">
                                <template slot-scope="{row}">
                                    <el-image style="width: 50px; height: 50px" :src="row.code_nei_image"
                                        :preview-src-list="[row.code_nei_image]">
                                    </el-image>
                                </template>
                            </el-table-column>
                        <el-table-column prop="code_image" label="外盖二维码" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <el-image style="width: 50px; height: 50px" :src="row.code_image"
                                    :preview-src-list="[row.code_image]">
                                </el-image>
                            </template>
                        </el-table-column>

                        <el-table-column prop="goods_code" label="商品编号" sortable="custom" show-overflow-tooltip
                            min-width="120" />
                        <el-table-column prop="image" label="商品图片" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <el-image style="width: 50px; height: 50px" :src="row.image"
                                    :preview-src-list="[row.image]">
                                </el-image>
                            </template>
                        </el-table-column>

                        <el-table-column prop="enterprise" label="生产企业" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="brand" label="品牌" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="producer" label="产地" sortable="custom" show-overflow-tooltip
                            min-width="120" />
                           

                        <el-table-column prop="type" label="类型" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="specs" label="规格" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="sort" label="排序" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column label="创建时间" sortable="custom" show-overflow-tooltip min-width="160">
                            <template slot-scope="{row}">{{ row.create_time*1000 | toDateString }}</template>
                        </el-table-column>
                        <el-table-column label="更新时间" sortable="custom" show-overflow-tooltip min-width="160">
                            <template slot-scope="{row}">{{ row.update_time*1000 | toDateString }}</template>
                        </el-table-column>
                        <el-table-column label="操作" width="130px" align="center" :resizable="false" fixed="right">
                            <template slot-scope="{row}">
                                <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false"
                                    v-if="permission.includes('sys:tracinggoods:edit')">修改</el-link>
                                <el-popconfirm title="确定要删除此追溯商品吗？" @confirm="remove(row)" class="ele-action">
                                    <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false"
                                        v-if="permission.includes('sys:tracinggoods:delete')">删除</el-link>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </template>
                </ele-data-table>
            </el-card>
            <!-- 编辑弹窗 -->
            <el-dialog :title="editForm.id?'修改追溯商品':'添加追溯商品'" :visible.sync="showEdit" width="800px"
                :destroy-on-close="true" :lock-scroll="false" @close="closeDialog" :close-on-click-modal="false">
                <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="auto" class="demo-ruleForm">

                    <el-form-item label="商品名称:" prop="name">
                        <el-input v-model="editForm.name" placeholder="请输入商品名称" clearable />
                    </el-form-item>

                    <el-form-item label="商品详情:" prop="info">
                        <el-input v-model="editForm.info" placeholder="请输入生产企业" clearable />
                    </el-form-item>

                    <el-form-item label="商品图片:" prop="image">
                        <ele-uploadimage :limit="1" v-model="editForm.image"></ele-uploadimage>

                    </el-form-item>

                    <el-form-item label="生产企业:" prop="enterprise">
                        <el-input v-model="editForm.enterprise" placeholder="请输入生产企业" clearable />
                    </el-form-item>

                    <el-form-item label="品牌:" prop="brand">
                        <el-input v-model="editForm.brand" placeholder="请输入品牌" clearable />
                    </el-form-item>

                    <el-form-item label="产地:" prop="producer">
                        <el-input v-model="editForm.producer" placeholder="请输入产地" clearable />
                    </el-form-item>

                    <el-form-item label="类型:" prop="type">
                        <el-input v-model="editForm.type" placeholder="请输入类型" clearable />
                    </el-form-item>

                    <el-form-item label="规格:" prop="specs">
                        <el-input v-model="editForm.specs" placeholder="请输入规格" clearable />
                    </el-form-item>
 <el-form-item label="香型:" prop="fragrance">
                        <el-input v-model="editForm.fragrance" placeholder="请输入香型" clearable />
                    </el-form-item>
                    <el-form-item label="度数:" prop="degree">
                        <el-input v-model="editForm.degree" placeholder="请输入度数" clearable />
                    </el-form-item>
                    <el-form-item label="售价:" prop="price">
                        <el-input v-model="editForm.price" placeholder="请输入售价" clearable />
                    </el-form-item>
                    <el-form-item label="验证时间:" prop="time">
                        <el-date-picker v-model="editForm.time" type="datetime" placeholder="选择添加验证时间" size="small"
                            value-format="yyyy-MM-dd HH:mm:ss">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="出库信息:" prop="out_info">
                        <el-input v-model="editForm.out_info" placeholder="请输入出库信息" clearable />
                    </el-form-item>
                    <el-form-item label="出库时间:" prop="out_time">
                        <el-date-picker v-model="editForm.out_time" type="datetime" placeholder="选择添加出库时间" size="small"
                            value-format="yyyy-MM-dd HH:mm:ss">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="公司信息:" prop="company">
                        <el-input v-model="editForm.company" placeholder="请输入公司信息" clearable />
                    </el-form-item>
                    
                    
                    <el-form-item label="排序:" prop="sort">
                        <el-input-number v-model="editForm.sort" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入排序" clearable />
                    </el-form-item>


                </el-form>
                <div slot="footer">
                    <el-button @click="closeDialog">取消</el-button>
                    <el-button type="primary" @click="save">保存</el-button>
                </div>
            </el-dialog>
        </div>
    </template>

    <script>
        import {
            mapGetters
        } from "vuex";

        import EleUploadimage from '@/components/EleUploadimage'

        export default {
            name: "SysTracingGoods",
            components: {
                EleUploadimage,
            },
            data() {
                return {
                    table: {
                        url: '/tracing/TracingGoods/index',
                        where: {
                            "image": [],
                            "code_image": []
                        }
                    }, // 表格配置
                    choose: [], // 表格选中数据
                    showEdit: false, // 是否显示表单弹窗
                    editForm: {
                        "image": [],
                        "code_image": []
                    }, // 表单数据
                    editFormTemp: {
                        "image": [],
                        "code_image": []
                    },
                    admin_list: [],
                    user_list: [],
                    search_show: false,
                    editRules: { // 表单验证规则
                  //   out_time:[{
                  //       required: true,
                  //       message: '请输入出库时间',
                  //       trigger: 'blur'
                  //   }],
                  
                  //   time:[{
                  //       required: true,
                  //       message: '请输入验证时间',
                  //       trigger: 'blur'
                  //   }],
                  //   out_info:[{
                  //       required: true,
                  //       message: '请输入出库信息',
                  //       trigger: 'blur'
                  //   }],
                  //   price:[{
                  //       required: true,
                  //       message: '请输入售价',
                  //       trigger: 'blur'
                  //   }],
                  //       name: [{
                  //           required: true,
                  //           message: '请输入商品名称',
                  //           trigger: 'blur'
                  //       }],



                    

                  //       goods_code: [{
                  //           required: true,
                  //           message: '请输入商品编号',
                  //           trigger: 'blur'
                  //       }],


                  //       image: [{
                  //           required: true,
                  //           message: '请上传商品图片',
                  //           trigger: 'blur'
                  //       }],


                  //       enterprise: [{
                  //           required: true,
                  //           message: '请输入生产企业',
                  //           trigger: 'blur'
                  //       }],


                  //       brand: [{
                  //           required: true,
                  //           message: '请输入品牌',
                  //           trigger: 'blur'
                  //       }],


                  //       producer: [{
                  //           required: true,
                  //           message: '请输入产地',
                  //           trigger: 'blur'
                  //       }],


                  //       code_image: [{
                  //           required: true,
                  //           message: '请上传二维码',
                  //           trigger: 'blur'
                  //       }],


                  //       type: [{
                  //           required: true,
                  //           message: '请输入类型',
                  //           trigger: 'blur'
                  //       }],


                       


                  //       create_time: [{
                  //           required: true,
                  //           message: '请选择创建时间',
                  //           trigger: 'blur'
                  //       }],


                    },
                }
            },
            computed: {
                ...mapGetters(["permission"]),
                initEditor() {
                    return {
                        height: 400,
                        file_picker_callback: this.file_picker_callback,
                        skin_url: this.$store.state.theme.theme === 'dark' ? '/tinymce/skins/ui/oxide-dark' :
                            '/tinymce/skins/ui/oxide',
                        content_css: this.$store.state.theme.theme === 'dark' ?
                            '/tinymce/skins/content/dark/content.css' : '/tinymce/skins/content/default/content.css',
                        images_upload_handler: (blobInfo, success, error) => {
                            let file = blobInfo.blob();
                            // 使用axios上传
                            const formData = new FormData();
                            formData.append('file', file, file.name);
                            this.$http.post('/upload/uploadImage', formData).then(res => {
                                if (res.data.code == 0) {
                                    success(res.data.data);
                                } else {
                                    error(res.data.msg);
                                }
                            }).catch(e => {
                                error(e.message);
                            });
                        }
                    };
                }
            },
            mounted() {

            },
            methods: {

                /**
                 * 关闭
                 */
                closeDialog() {
                    this.showEdit = false;
                    this.editForm = JSON.parse(JSON.stringify(this.editFormTemp));
                },
                /**
                 * 显示编辑
                 */
                edit(row) {
                    this.$http.get('/tracing/TracingGoods/info?id=' + row.id).then(res => {
                        if (res.data.code === 0) {
                            this.showEdit = true;
                            setTimeout(() => {
                                this.editForm = res.data.data;
                            }, 100);
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },
                /**
                 * 保存编辑
                 */
                save() {
                    this.$refs['editForm'].validate((valid) => {
                        if (valid) {
                            const loading = this.$loading({
                                lock: true
                            });
                            this.$http.post('/tracing/TracingGoods/edit', this.editForm).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.showEdit = false;
                                    this.$message({
                                        type: 'success',
                                        message: res.data.msg
                                    });
                                    this.$refs.table.reload();
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        } else {
                            return false;
                        }
                    });
                },
                /**
                 * 刪除(批量刪除)
                 */
                remove(row) {
                    console.log(row)
                    if (!row) { // 批量删除
                        if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                        let ids = this.choose.map(d => d.id);
                        this.$confirm('确定要删除选中的追溯商品吗?', '提示', {
                            type: 'warning'
                        }).then(() => {
                            const loading = this.$loading({
                                lock: true
                            });
                            this.$http.post('/tracing/TracingGoods/delete', {
                                id: ids
                            }).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.$message({
                                        type: 'success',
                                        message: res.data.msg
                                    });
                                    this.$refs.table.reload();
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        }).catch(() => 0);
                    } else { // 单个删除
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/tracing/TracingGoods/delete', {
                            id: row.id
                        }).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }
                },

                /* 导出数据Excel */
                exportExcel() {
                    let ids = this.choose.map(d => d.id)
                    if (ids.length == 0) {
                        this.$message.error('请选择要导出的数据');
                        return false;
                    }
                    this.$http
                        .post("/tracing/TracingGoods/exportExcel", {
                            id: ids
                        })
                        .then((res) => {
                            let data = res.data;
                            if (data.code == 0) {
                                // 下载文件
                                window.location.href = data.data;
                                this.$message({
                                    type: "success",
                                    message: "导出成功",
                                });
                            } else {
                                this.$message.error("导出失败");
                            }
                        })
                },


                /**
         * 更改状态

         */
                editStatus(row, name) {
                    const loading = this.$loading({
                        lock: true
                    });
                    let data = {
                        id: row.id,
                        name: name,
                        value: row[name],
                    }
                    this.$http.post("/tracing/TracingGoods/status", data).then(res => {
                        loading.close();
                        if (res.data.code === 0) {
                            this.$message({
                                type: 'success',
                                message: res.data.msg
                            });
                        } else {
                            row[name] = !row[name] ? 1 : 0;
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        loading.close();
                        this.$message.error(e.message);
                    });
                },
            }
        }
    </script>

    <style scoped>
        .ele-block>>>.el-upload,
        .ele-block>>>.el-upload-dragger {
            width: 100%;
        }
    </style>